import { createApiHook } from './utils/createApiHook';
import { CounterpartyRepository, ExternalFinancialInstitution } from '~/repositories';

export const useInstitutions = createApiHook<ExternalFinancialInstitution, string>(CounterpartyRepository.institution);
